// utils
import axios from '../../../utils/axios';

const updateSubscription = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `/lexus/wallet/api/subscriptions/pricings`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { updateSubscription };
